import axios from "../axios";

export async function get_all_accounts() {
    return await axios.get('/api/ml_accounts/all');
}